/* Luxury Box collection filters — chips + bottom sheets (mobile) / left rail (desktop).
   Works on top of Shopify's native storefront filters: every input keeps its
   param_name/value, so applying = building a URL and navigating (canonical, shareable).
   Preview counts come from the Section Rendering API. No size conversion anywhere. */
(function () {
  'use strict';
  var SIZE_KEY = 'lb_size';           // {us:"10.5", eu:"44", apparel:"L", waist:"32"}
  var ONLY_KEY = 'lb_only_mine';      // "1" | "0"
  var SIZE_PARAM = 'filter.v.option.size';
  var AVAIL_PARAM = 'filter.v.availability';
  var TYPE_PARAM = 'filter.p.product_type';   // hidden Search & Discovery filter, set only by the size picker
  var KIND_PARAM = 'lb_sz';                   // which row each size was picked from: "waist:38,eu:44"
  var TAB_PARAM = 'lb_tab';                   // "clothing" | "shoes" when both kinds are picked
  var SHOE_KINDS = ['us', 'eu', 'women-s', 'kids'];
  var SHOE_TYPES = ['Sneakers', 'Footwear'];
  var SAVED_KINDS = { apparel: 'letter', waist: 'waist', us: 'us', eu: 'eu' }; // lb_size key -> size row

  function readSize() { try { return JSON.parse(localStorage.getItem(SIZE_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function onlyMine() { try { var v = localStorage.getItem(ONLY_KEY); return v === null ? true : v === '1'; } catch (e) { return true; } }
  function setOnlyMine(on) { try { localStorage.setItem(ONLY_KEY, on ? '1' : '0'); } catch (e) {} }

  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = '1';
    var sectionId = root.dataset.sectionId;
    var baseUrl = root.dataset.collectionUrl || location.pathname;
    var inStockOnly = root.dataset.inStockOnly === 'true';
    var isSearch = root.dataset.lbSource === 'search';
    // CRO round 2 (Sep 27): collections no longer force filter.v.availability=1. Facet counts on the
    // default view include sold-out items, so filters keep whatever availability state the URL already
    // has ("Hide sold out" on = stays on; off = sold-out items stay in, sorted below in-stock ones).
    // Only /search keeps forcing in-stock (its head script enforces it anyway).
    var defaultSort = root.dataset.defaultSort || '';
    var inStockNow = parseInt(root.dataset.inStockCount || '-1', 10); // in-stock matches for the current filters (-1 = unknown)
    var SORT_AVAIL_KEY = 'lb_avail_by_sort';
    function keepAvail(p) { if (isSearch && inStockOnly && !p.has(AVAIL_PARAM)) p.set(AVAIL_PARAM, '1'); return p; }
    function sortAvailFlag(v) { try { if (v) sessionStorage.setItem(SORT_AVAIL_KEY, location.pathname); else sessionStorage.removeItem(SORT_AVAIL_KEY); } catch (e) {} }
    function sortAvailFlagged() { try { return sessionStorage.getItem(SORT_AVAIL_KEY) === location.pathname; } catch (e) { return false; } }
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lb-panel]'));
    var scrim = root.querySelector('[data-lb-scrim]');
    var badge = root.querySelector('[data-lb-badge]');
    var isDesktop = function () { return window.matchMedia('(min-width: 1024px)').matches; };
    var previewTimer = null, previewReq = 0;

    // ---------- size kinds (Oct 22) ----------
    // Waist and EU shoe share numbers (36–44). Each picked size keeps the row it came from, so waist 38
    // and EU 38 are separate picks. When a shared number is picked, the list is narrowed with the hidden
    // Product type filter: Letter/Waist -> every type except shoes, US/EU -> Sneakers/Footwear.
    // Shopify can't show "38 pants or 44 shoes" in one list (sizes OR, filters AND), so when both kinds
    // are picked the page splits into two tabs. Without the Product type filter in Search & Discovery
    // (data-lb-types empty) sizes stay plain OR, exactly as before.
    var typeValues = (root.dataset.lbTypes || '').split('|').filter(Boolean);
    var lastSide = null;
    function sizeInputs() { return Array.prototype.slice.call(root.querySelectorAll('[data-lb-panel="v-option-size"] input[data-lb-size-value]')); }
    function kindOf(i) { var g = i.closest('[data-lb-size-group]'); return g ? g.dataset.lbSizeGroup : 'other'; }
    function isShoe(kind) { return SHOE_KINDS.indexOf(kind) !== -1; }
    function sideOf(kind) { return isShoe(kind) ? 'shoes' : 'clothing'; }
    var sharedSizes = {};
    (function () {
      var w = {};
      sizeInputs().forEach(function (i) { if (kindOf(i) === 'waist') w[i.dataset.lbSizeValue] = true; });
      sizeInputs().forEach(function (i) { if (kindOf(i) === 'eu' && w[i.dataset.lbSizeValue]) sharedSizes[i.dataset.lbSizeValue] = true; });
    })();
    function typesFor(side) { return typeValues.filter(function (t) { return (SHOE_TYPES.indexOf(t) !== -1) === (side === 'shoes'); }); }
    function pick(i) { return { kind: kindOf(i), value: i.dataset.lbSizeValue, param: i.value || i.dataset.lbSizeValue }; }
    function parseKinds(str) {
      return String(str || '').split(',').map(function (x) {
        var k = x.split(':'); if (k.length !== 2 || !k[1]) return null;
        var i = sizeInputs().filter(function (el) { return kindOf(el) === k[0] && el.dataset.lbSizeValue === k[1]; })[0];
        return { kind: k[0], value: k[1], param: i ? (i.value || k[1]) : k[1] };
      }).filter(Boolean);
    }
    function picksFromInputs() {
      var out = [], seen = {};
      sizeInputs().forEach(function (i) { if (!i.checked) return; var pk = pick(i), k = pk.kind + ':' + pk.value; if (!seen[k]) { seen[k] = true; out.push(pk); } });
      return out;
    }
    function sidesOf(picks) {
      return { shoes: picks.filter(function (pk) { return isShoe(pk.kind); }), clothing: picks.filter(function (pk) { return !isShoe(pk.kind); }) };
    }
    // Write size picks into URL params, replacing any size / type / kind / tab params already there.
    function applyPicks(p, picks, tabPref) {
      [SIZE_PARAM, TYPE_PARAM, KIND_PARAM, TAB_PARAM].forEach(function (k) { p.delete(k); });
      if (!picks.length) return p;
      var add = function (list) { var seen = {}; list.forEach(function (pk) { if (!seen[pk.param]) { seen[pk.param] = true; p.append(SIZE_PARAM, pk.param); } }); };
      var clash = typeValues.length > 0 && picks.some(function (pk) { return sharedSizes[pk.value]; });
      if (!clash) { add(picks); return p; }
      var s = sidesOf(picks);
      var both = s.shoes.length > 0 && s.clothing.length > 0;
      var side = both ? (tabPref === 'shoes' ? 'shoes' : 'clothing') : (s.shoes.length ? 'shoes' : 'clothing');
      p.set(KIND_PARAM, picks.map(function (pk) { return pk.kind + ':' + pk.value; }).join(','));
      if (both) p.set(TAB_PARAM, side);
      add(s[side]);
      typesFor(side).forEach(function (t) { p.append(TYPE_PARAM, t); });
      return p;
    }

    // sticky offset under the theme header
    var header = document.querySelector('.theme__header, [data-header-height], .site-header');
    if (header) root.style.setProperty('--lb-sticky-top', Math.max(0, Math.round(header.getBoundingClientRect().height)) + 'px');

    // ---------- URL building ----------
    function currentParams() {
      var p = new URLSearchParams(location.search);
      p.delete('page');
      return p;
    }
    function paramsFromInputs(scopePanel) {
      // Start from the URL, replace the params owned by panels with their current input state.
      var p = currentParams();
      var owned = {};
      panels.forEach(function (panel) {
        panel.querySelectorAll('input[name^="filter."]').forEach(function (i) { owned[i.name] = true; });
      });
      Object.keys(owned).forEach(function (k) { p.delete(k); });
      panels.forEach(function (panel) {
        panel.querySelectorAll('input[name^="filter."]').forEach(function (i) {
          if (i.name === SIZE_PARAM) return; // sizes are written by applyPicks (they need their row)
          if (i.type === 'checkbox') {
            if (i.checked) {
              p.append(i.name, i.value);
              if (i.dataset.lbAlso) i.dataset.lbAlso.split('|').forEach(function (v) { if (v) p.append(i.name, v); });
            }
          }
          else if (i.type === 'number') { if (i.value !== '') p.set(i.name, i.value); }
        });
      });
      applyPicks(p, picksFromInputs(), lastSide || currentParams().get(TAB_PARAM));
      return keepAvail(p);
    }
    function go(p) {
      if (isSearch && !p.has('type')) p.set('type', 'product');
      var qs = p.toString();
      location.assign(baseUrl + (qs ? '?' + qs : ''));
    }

    // ---------- sort (CRO round 2) ----------
    // A shopper-chosen sort (anything but the collection default) switches to the in-stock-only view,
    // as live does, so the order they asked for runs across every page. Skipped when the current
    // result has no in-stock items (fully sold-out collection or a sold-out-only filter): that would
    // be an empty page, so it stays on all items and the grid renders one pass in true sort order.
    // Going back to the default sort removes the in-stock filter again only if the sort added it.
    function sortParams(v) {
      var p = currentParams();
      if (isSearch) { p.set('sort_by', v); return p; }
      if (!v || v === defaultSort) {
        p.delete('sort_by');
        if (sortAvailFlagged()) p.delete(AVAIL_PARAM);
        sortAvailFlag(false);
        return p;
      }
      p.set('sort_by', v);
      if (inStockOnly && !p.has(AVAIL_PARAM) && inStockNow > 0) { p.set(AVAIL_PARAM, '1'); sortAvailFlag(true); }
      else if (p.has(AVAIL_PARAM) && inStockNow === 0) { p.delete(AVAIL_PARAM); sortAvailFlag(false); } // round 2b: in-stock-only here would be empty
      return p;
    }

    // ---------- match counts (CRO round 2b) ----------
    // countFor(params) -> Promise<number>: the match count of that result page, read from the Section
    // Rendering API (data-match-count; includes sold-out items unless "Hide sold out" is on). Cached per
    // URL; -1 = unknown (request failed). Used by the mobile preview, the price bands and safeGo().
    var countCache = {};
    function countFor(p) {
      var q = new URLSearchParams(p.toString());
      q.delete('page'); q.delete('section_id');
      if (isSearch && !q.has('type')) q.set('type', 'product');
      q.set('section_id', sectionId);
      var key = q.toString();
      if (!countCache[key]) {
        countCache[key] = fetch(baseUrl + '?' + key, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var el = doc.querySelector('[data-section-type="luxbox-collection"]');
            if (!el) throw new Error('no section');
            return parseInt(el.dataset.matchCount || el.dataset.count || '0', 10);
          })
          .catch(function () { delete countCache[key]; return -1; });
      }
      return countCache[key];
    }
    // Navigate only if the result has at least one item; otherwise stay and call onZero().
    function safeGo(p, onZero) {
      return countFor(p).then(function (n) { if (n === 0) { if (onZero) onZero(); } else go(p); });
    }

    // ---------- price bands + typed price (CRO round 2b) ----------
    // Price has no per-value counts in Liquid (only range_max), and a band can be empty anywhere in the
    // range, so each band's match count is fetched for the current URL state (other filters + Hide sold
    // out included). Zero-result bands are disabled (greyed, unclickable). Band clicks and typed prices
    // are re-checked before navigating, so a price filter can never land on an empty page.
    function priceInputs(panel) { return { mn: panel.querySelector('input[name$=".gte"]'), mx: panel.querySelector('input[name$=".lte"]') }; }
    function bandParams(band) {
      var io = priceInputs(band.closest('[data-lb-panel]'));
      var p = keepAvail(currentParams());
      if (io.mn) { p.delete(io.mn.name); if (band.dataset.min && band.dataset.min !== '0') p.set(io.mn.name, band.dataset.min); }
      if (io.mx) { p.delete(io.mx.name); if (band.dataset.max && band.dataset.max !== '0') p.set(io.mx.name, band.dataset.max); }
      return p;
    }
    function disableBand(band) { band.checked = false; band.disabled = true; band.setAttribute('data-lb-zero', ''); }
    var bandsMarked = false;
    function markBands() {
      if (bandsMarked) return; bandsMarked = true;
      root.querySelectorAll('[data-lb-band]').forEach(function (band) {
        countFor(bandParams(band)).then(function (n) { if (n === 0) disableBand(band); });
      });
    }
    function priceGo(input) {
      var p = paramsFromInputs();
      safeGo(p, function () {
        if (!input || !input.setCustomValidity) return;
        input.setCustomValidity('Nothing in that price range right now');
        input.reportValidity();
        input.addEventListener('input', function clr() { input.setCustomValidity(''); input.removeEventListener('input', clr); });
      });
    }

    // ---------- preview count ----------
    function refreshPreview(panel) {
      clearTimeout(previewTimer);
      previewTimer = setTimeout(function () {
        var p = paramsFromInputs();
        var req = ++previewReq;
        var out = panel.querySelector('[data-lb-preview]');
        if (out) out.textContent = '…';
        countFor(p).then(function (n) {
          if (req !== previewReq) return;
          if (n < 0) { if (out) out.textContent = ''; return; }
          if (out) out.textContent = n.toLocaleString();
          var apply = panel.querySelector('[data-lb-apply]');
          if (apply) apply.disabled = (n === 0);
        });
      }, 250);
    }

    // ---------- open / close sheets ----------
    var openPanel = null;
    function open(key) {
      var panel = key === 'all' ? panels[0] : root.querySelector('[data-lb-panel="' + key + '"]');
      if (!panel) return;
      if (isDesktop()) { panel.removeAttribute('data-collapsed'); panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); return; }
      close();
      panel.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      openPanel = panel;
      if (panel.querySelector('[data-lb-band]')) markBands();
      refreshPreview(panel);
    }
    function close() {
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      if (scrim) scrim.classList.remove('is-open');
      document.body.style.overflow = '';
      openPanel = null;
    }
    function filterList(input) {
      var q = (input.value || '').trim().toLowerCase();
      var list = input.closest('.lb-list');
      list.querySelectorAll('[data-lb-item]').forEach(function (it) { it.style.display = (!q || it.dataset.lbItem.indexOf(q) !== -1) ? '' : 'none'; });
    }

    // ---------- events ----------
    function onClick(e) {
      var t = e.target;
      var opener = t.closest('[data-lb-open]');
      if (opener) { e.preventDefault(); open(opener.dataset.lbOpen); return; }
      if (t.closest('[data-lb-close]') || t === scrim) { e.preventDefault(); close(); return; }
      var apply = t.closest('[data-lb-apply]');
      if (apply) {
        e.preventDefault();
        if (apply.disabled) return;
        safeGo(paramsFromInputs(), function () { apply.disabled = true; var o = apply.querySelector('[data-lb-preview]'); if (o) o.textContent = '0'; });
        return;
      }
      var clr = t.closest('[data-lb-clear]');
      if (clr) {
        e.preventDefault();
        var key = clr.dataset.lbClear;
        var scope = key === 'all' ? panels : [root.querySelector('[data-lb-panel="' + key + '"]')];
        scope.forEach(function (panel) { if (!panel) return; panel.querySelectorAll('input').forEach(function (i) { if (i.type === 'checkbox' || i.type === 'radio') i.checked = false; else if (i.type === 'number' || i.type === 'search') i.value = ''; }); });
        if (isDesktop()) go(paramsFromInputs()); else refreshPreview(clr.closest('.lb-panel'));
        return;
      }
      var band = t.closest('[data-lb-band]');
      if (band) {
        if (band.disabled || band.hasAttribute('data-lb-zero')) { e.preventDefault(); return; }
        var panel = band.closest('[data-lb-panel]');
        var mn = panel.querySelector('input[name$=".gte"]'), mx = panel.querySelector('input[name$=".lte"]');
        var was = [mn ? mn.value : '', mx ? mx.value : ''];
        if (mn) mn.value = band.dataset.min === '0' ? '' : band.dataset.min;
        if (mx) mx.value = (band.dataset.max === '0' || band.dataset.max === '') ? '' : band.dataset.max;
        if (isDesktop()) safeGo(paramsFromInputs(), function () { disableBand(band); if (mn) mn.value = was[0]; if (mx) mx.value = was[1]; });
        return;
      }
      var head = t.closest('.lb-panel__head');
      if (head && isDesktop() && !t.closest('[data-lb-close]')) { var pnl = head.closest('[data-lb-panel]'); if (pnl.hasAttribute('data-collapsed')) pnl.removeAttribute('data-collapsed'); else pnl.setAttribute('data-collapsed', ''); }
      var edit = t.closest('[data-lb-edit-size]');
      if (edit) { e.preventDefault(); if (window.LuxboxNav) window.LuxboxNav.open('size'); else location.href = '/'; }
      var clr = t.closest('[data-lb-clear-size]');
      if (clr) {
        e.preventDefault();
        try { localStorage.removeItem(SIZE_KEY); } catch (err) {}
        window.dispatchEvent(new CustomEvent('lb:size', { detail: {} }));
        var cp = currentParams();
        if (cp.getAll(SIZE_PARAM).length || cp.get(KIND_PARAM)) { applyPicks(cp, [], null); go(cp); }
        return;
      }
      var sw = t.closest('[data-lb-only-mine]');
      if (sw) { e.preventDefault(); var on = !sw.classList.contains('is-on'); setOnlyMine(on); sw.classList.toggle('is-on', on); sw.setAttribute('aria-checked', String(on)); applyMySize(on, true); }
    }
    root.addEventListener('click', onClick);
    root.addEventListener('submit', function (e) {
      if (!e.target.matches('.lb-hide-sold')) return;
      e.preventDefault(); sortAvailFlag(false);
      var p = currentParams(); p.set(AVAIL_PARAM, '1'); go(p);
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-lb-show-sold]'); if (!a) return;
      e.preventDefault(); sortAvailFlag(false);
      var p = currentParams(); p.delete(AVAIL_PARAM); go(p);
    });
    root.addEventListener('change', function (e) {
      // the side (clothing / shoes) of the latest size picked decides which tab opens
      if (e.target.matches('[data-lb-size-value]') && e.target.checked) lastSide = sideOf(kindOf(e.target));
      var panel = e.target.closest('[data-lb-panel]');
      if (!panel) {
        if (e.target.matches('[data-lb-sort]')) { go(sortParams(e.target.value)); }
        // store select: single-select on the Location filter param ("" = all stores)
        else if (e.target.matches('[data-lb-store-select]')) {
          var sk = e.target.dataset.lbStoreParam || 'filter.p.m.custom.location';
          var sp = currentParams(); sp.delete(sk);
          if (e.target.value) sp.append(sk, e.target.value);
          go(keepAvail(sp));
        }
        return;
      }
      if (isDesktop()) { if (e.target.type === 'checkbox') go(paramsFromInputs()); }
      else refreshPreview(panel);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Enter' && e.target.type === 'number' && isDesktop()) { e.preventDefault(); priceGo(e.target); }
    });
    root.addEventListener('input', function (e) { if (e.target.matches('[data-lb-search]')) filterList(e.target); });
    root.querySelectorAll('.lb-price input').forEach(function (i) { i.addEventListener('change', function () { if (isDesktop()) priceGo(i); }); });
    // desktop: the price panel is open in the rail, so check the bands once the page is idle (after LCP)
    if (root.querySelector('[data-lb-band]') && isDesktop()) {
      var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
      var kick = function () { idle(markBands, { timeout: 3000 }); };
      if (document.readyState === 'complete') kick(); else window.addEventListener('load', kick, { once: true });
    }

    // size cells arrive in Shopify's order; show them numerically (letters in wear order)
    var LETTER_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL', '4XL', 'XXXXL', 'OS', 'ONE SIZE'];
    function sizeRank(v) {
      var n = parseFloat(v); if (!isNaN(n)) return n;
      var i = LETTER_ORDER.indexOf(String(v).toUpperCase()); return i === -1 ? 999 : 100 + i;
    }
    root.querySelectorAll('[data-lb-size-group] .lb-cells').forEach(function (grid) {
      var cells = Array.prototype.slice.call(grid.children);
      cells.sort(function (a, b) { return sizeRank(a.querySelector('input').dataset.lbSizeValue) - sizeRank(b.querySelector('input').dataset.lbSizeValue); });
      cells.forEach(function (c) { grid.appendChild(c); });
    });

    // size kinds (Oct 22): Liquid ticks a shared number in both rows; the URL says which row was picked
    (function sizeStateFromUrl() {
      var p = currentParams();
      var kinds = parseKinds(p.get(KIND_PARAM));
      if (!kinds.length) return;
      sizeInputs().forEach(function (i) { i.checked = kinds.some(function (k) { return k.kind === kindOf(i) && k.value === i.dataset.lbSizeValue; }); });
      // the hidden type filter zeroes the other side's size counts, but those sizes are still here: keep them pickable
      var side = p.get(TAB_PARAM) || (kinds.some(function (k) { return isShoe(k.kind); }) ? 'shoes' : 'clothing');
      sizeInputs().forEach(function (i) { if (sideOf(kindOf(i)) !== side) i.disabled = false; });
    })();
    // both kinds picked with a shared number: two tabs above the grid (each one exact), with match counts
    (function sizeTabs() {
      var p = currentParams();
      var tab = p.get(TAB_PARAM);
      var picks = parseKinds(p.get(KIND_PARAM));
      if (!tab || !picks.length) return;
      var s = sidesOf(picks);
      if (!s.shoes.length || !s.clothing.length) return;
      var PREFIX = { waist: 'Waist ', eu: 'EU ', us: 'US ' };
      var bar = document.createElement('div'); bar.className = 'lb-tabs'; bar.setAttribute('role', 'tablist');
      [['clothing', 'Clothing'], ['shoes', 'Shoes']].forEach(function (t) {
        var on = t[0] === tab;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'lb-tab' + (on ? ' is-on' : '');
        b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', on ? 'true' : 'false');
        var tt = document.createElement('span'); tt.className = 'lb-tab__t';
        tt.textContent = t[1] + ' · ' + s[t[0]].map(function (pk) { return (PREFIX[pk.kind] || '') + pk.value; }).join(', ');
        var nn = document.createElement('span'); nn.className = 'lb-tab__n';
        b.appendChild(tt); b.appendChild(nn);
        var tp = keepAvail(applyPicks(currentParams(), picks, t[0]));
        if (!on) b.addEventListener('click', function () { go(tp); });
        // in-stock count, same number as the "{n} in stock" line under the title
        var show = function (n) { if (n >= 0) nn.textContent = n.toLocaleString() + ' in stock'; };
        if (on) show(parseInt(root.dataset.count || '-1', 10));
        else {
          var q = new URLSearchParams(tp.toString()); q.delete('page');
          if (isSearch && !q.has('type')) q.set('type', 'product');
          q.set('section_id', sectionId);
          fetch(baseUrl + '?' + q.toString(), { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              var el = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-section-type="luxbox-collection"]');
              show(el ? parseInt(el.dataset.count || '-1', 10) : -1);
            })
            .catch(function () {});
        }
        bar.appendChild(b);
      });
      var layout = root.querySelector('.lb-layout');
      if (layout) layout.parentNode.insertBefore(bar, layout);
    })();

    // synthesized size cells (S&D value groups hide the raw sizes): Liquid can't see the URL,
    // so mark them checked here and reflect that in the chip + badge
    (function syncSynth() {
      var urlSizes = currentParams().getAll(SIZE_PARAM);
      if (!urlSizes.length) return;
      var hit = [];
      root.querySelectorAll('[data-lb-synth][data-lb-size-value]').forEach(function (i) {
        if (urlSizes.indexOf(i.value) !== -1) { i.checked = true; hit.push(i.dataset.lbSizeValue); }
      });
      if (!hit.length) return;
      var chip = root.querySelector('[data-lb-open="v-option-size"]');
      if (chip && !chip.classList.contains('is-active')) {
        chip.classList.add('is-active');
        chip.childNodes[0].nodeValue = 'Size · ' + hit.join(', ');
        if (badge) { var n = parseInt(badge.textContent || '0', 10) || 0; badge.textContent = n + 1; badge.hidden = false; }
        var bar = root.querySelector('[data-lb-bar]');
        if (bar && !bar.querySelector('.lb-chip--clear')) { var a = document.createElement('a'); a.className = 'lb-chip lb-chip--clear'; a.href = baseUrl; a.textContent = 'Clear all'; bar.appendChild(a); }
      }
    })();
    // empty state: say which size came up empty, and offer "Show all sizes" (keeps the other filters)
    (function emptyState() {
      var a = root.querySelector('[data-lb-clear-size-link]'); if (!a) return;
      var p = currentParams(); var sizes = p.getAll(SIZE_PARAM); if (!sizes.length) return;
      var msg = root.querySelector('[data-lb-empty-msg]');
      if (msg) msg.textContent = 'Nothing in ' + sizes.join(' / ') + ' right now.';
      p.delete(SIZE_PARAM); a.href = baseUrl + (p.toString() ? '?' + p.toString() : ''); a.hidden = false;
    })();

    // list panels: options with zero matches sink to the bottom
    root.querySelectorAll('.lb-list').forEach(function (list) {
      Array.prototype.slice.call(list.querySelectorAll('[data-lb-item]')).forEach(function (it) {
        var i = it.querySelector('input'); if (i && i.disabled) list.appendChild(it);
      });
    });

    // ---------- "your size" ----------
    var sizePanel = root.querySelector('[data-lb-panel="v-option-size"]');
    // saved sizes that exist on this page, each matched in its own row (a saved EU 44 never picks waist 44)
    function savedValuesPresent() {
      var s = readSize(), out = [];
      if (!sizePanel) return out;
      Object.keys(SAVED_KINDS).forEach(function (key) {
        if (!s[key]) return;
        var i = sizeInputs().filter(function (x) { return kindOf(x) === SAVED_KINDS[key] && x.dataset.lbSizeValue === String(s[key]) && !x.disabled; })[0];
        if (i) out.push(pick(i));
      });
      return out;
    }
    function renderMySize() {
      var box = root.querySelector('[data-lb-mysize]'); if (!box) return;
      var s = readSize(); var cells = box.querySelector('[data-lb-mysize-cells]');
      var items = [['US', s.us], ['EU', s.eu], ['', s.apparel], ['W', s.waist]].filter(function (x) { return x[1]; });
      if (!items.length) { box.removeAttribute('data-has-size'); return; }
      box.setAttribute('data-has-size', '');
      cells.innerHTML = items.map(function (x) { return '<span class="lb-mysize__cell">' + (x[0] ? x[0] + ' ' : '') + x[1] + '</span>'; }).join('');
      var sw = box.querySelector('[data-lb-only-mine]'); var on = onlyMine(); sw.classList.toggle('is-on', on); sw.setAttribute('aria-checked', String(on));
    }
    function applyMySize(on, navigate) {
      var present = savedValuesPresent();
      var p = currentParams();
      var urlSizes = p.getAll(SIZE_PARAM);
      if (on) {
        if (!present.length) return;
        if (urlSizes.length) return; // shopper already chose sizes on this page
        applyPicks(p, present, null);
        keepAvail(p);
        try { sessionStorage.setItem('lb_auto_size', '1'); } catch (e) {}
        go(p);
      } else if (navigate) {
        applyPicks(p, [], null); go(p);
      }
    }
    renderMySize();
    // the nav drawer edits the saved size: re-render, and once it closes, apply it
    window.addEventListener('lb:size', renderMySize);
    window.addEventListener('lb:size:commit', function () {
      renderMySize();
      var p = currentParams();
      if (!onlyMine()) return;
      var present = savedValuesPresent();
      if (!present.length) { if (p.getAll(SIZE_PARAM).length) { applyPicks(p, [], null); go(p); } return; }
      applyPicks(p, present, null);
      go(keepAvail(p));
    });
    // Auto-apply once per page view when the shopper has a saved size and hasn't filtered yet.
    (function autoApply() {
      var p = currentParams();
      if (p.getAll(SIZE_PARAM).length) return;
      if (!onlyMine()) return;
      var present = savedValuesPresent();
      if (!present.length) return;
      var sz = readSize();
      var pathKey = location.pathname + (isSearch ? '?q=' + (new URLSearchParams(location.search).get('q') || '') : '');
      var key = 'lb_auto_' + pathKey + '|' + [sz.us, sz.eu, sz.apparel, sz.waist].join(',');
      try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (e) {}
      applyMySize(true, false);
    })();

    // Collections are no longer forced to filter.v.availability=1 (availability fix, Sep 27): the default
    // view lists in-stock items first, then sold-out (snippets/luxbox-grid.liquid).

    // for sections/lb-size-first.liquid (the "Shop your size" pill row): it ticks the panel's size
    // checkboxes, then asks for the same URL the panel would build
    root.lbSize = {
      inputs: sizeInputs,
      kindOf: kindOf,
      apply: function (side) { if (side) lastSide = side; go(paramsFromInputs()); }
    };
  }

  function boot() { document.querySelectorAll('[data-section-type="luxbox-collection"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.LuxboxSize = { read: readSize, onlyMine: onlyMine, KEY: SIZE_KEY, ONLY_KEY: ONLY_KEY };
})();
